import React from 'react';
import Typography from '@material-ui/core/Typography';

export function StepFinishContent() {
  return (
    <Typography variant="body1">Výrobce OZO byl úspěšně registrován</Typography>
  );
}
